import { render, staticRenderFns } from "./SaleAgentByPersonListPage.vue?vue&type=template&id=488e4517&scoped=true"
import script from "./SaleAgentByPersonListPage.vue?vue&type=script&lang=js"
export * from "./SaleAgentByPersonListPage.vue?vue&type=script&lang=js"
import style0 from "./SaleAgentByPersonListPage.vue?vue&type=style&index=0&id=488e4517&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e4517",
  null
  
)

export default component.exports